import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ReportCard = ({ report }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [shareExpiration, setShareExpiration] = useState('7days');
  const [showShareModal, setShowShareModal] = useState(false);

  const getReportTypeConfig = (type) => {
    switch (type) {
      case 'Compliance':
        return { icon: 'FileCheck', color: 'text-success', bgColor: 'bg-success/10' };
      case 'Treatment':
        return { icon: 'Droplets', color: 'text-primary', bgColor: 'bg-primary/10' };
      case 'Performance':
        return { icon: 'TrendingUp', color: 'text-accent', bgColor: 'bg-accent/10' };
      default:
        return { icon: 'FileText', color: 'text-muted-foreground', bgColor: 'bg-muted/10' };
    }
  };

  const handleDownload = (format) => {
    console.log(`Downloading report ${report?.id} in ${format} format`);
    alert(`Downloading ${report?.title} as ${format}`);
  };

  const handleShare = () => {
    console.log(`Sharing report ${report?.id} with expiration: ${shareExpiration}`);
    alert(`Share link generated for ${report?.title}. Expires in ${shareExpiration}.`);
    setShowShareModal(false);
  };

  const typeConfig = getReportTypeConfig(report?.type);

  return (
    <div className="bg-card border border-border rounded-lg p-4 hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between">
        <div className="flex items-start space-x-4 flex-1">
          <div className={`p-3 rounded-lg ${typeConfig?.bgColor}`}>
            <Icon name={typeConfig?.icon} size={24} className={typeConfig?.color} />
          </div>
          
          <div className="flex-1">
            <h4 className="font-semibold text-foreground">{report?.title}</h4>
            <div className="flex items-center space-x-4 mt-2 text-sm text-muted-foreground">
              <span className="flex items-center space-x-1">
                <Icon name="Calendar" size={14} />
                <span>{new Date(report?.generatedDate)?.toLocaleDateString()}</span>
              </span>
              <span className="flex items-center space-x-1">
                <Icon name="File" size={14} />
                <span>{report?.fileSize}</span>
              </span>
              <span className={`px-2 py-1 rounded text-xs font-medium ${typeConfig?.bgColor} ${typeConfig?.color}`}>
                {report?.type}
              </span>
            </div>
            
            {isExpanded && (
              <div className="mt-3 p-3 bg-muted/30 rounded-lg">
                <p className="text-sm text-foreground">{report?.summary}</p>
              </div>
            )}
          </div>
        </div>

        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="text-muted-foreground hover:text-foreground transition-colors"
        >
          <Icon name={isExpanded ? 'ChevronUp' : 'ChevronDown'} size={20} />
        </button>
      </div>
      {/* Action Buttons */}
      <div className="flex items-center space-x-2 mt-4 pt-4 border-t border-border">
        <Button
          variant="default"
          size="sm"
          iconName="Download"
          iconPosition="left"
          onClick={() => handleDownload('PDF')}
        >
          Download PDF
        </Button>
        <Button
          variant="outline"
          size="sm"
          iconName="FileSpreadsheet"
          iconPosition="left"
          onClick={() => handleDownload('CSV')}
        >
          Export CSV
        </Button>
        <Button
          variant="outline"
          size="sm"
          iconName="Share2"
          iconPosition="left"
          onClick={() => setShowShareModal(true)}
        >
          Share
        </Button>
      </div>
      {/* Share Modal */}
      {showShareModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={() => setShowShareModal(false)}>
          <div className="bg-card rounded-lg p-6 max-w-md w-full mx-4" onClick={(e) => e?.stopPropagation()}>
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-foreground">Share Report</h3>
              <button onClick={() => setShowShareModal(false)} className="text-muted-foreground hover:text-foreground">
                <Icon name="X" size={20} />
              </button>
            </div>
            
            <p className="text-sm text-muted-foreground mb-4">Generate a secure link to share this report</p>
            
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-foreground mb-2">Link Expiration</label>
                <select
                  value={shareExpiration}
                  onChange={(e) => setShareExpiration(e?.target?.value)}
                  className="w-full px-3 py-2 border border-border rounded-lg bg-background text-foreground"
                >
                  <option value="24hours">24 Hours</option>
                  <option value="7days">7 Days</option>
                  <option value="30days">30 Days</option>
                  <option value="never">Never Expire</option>
                </select>
              </div>
              
              <div className="flex space-x-2">
                <Button variant="default" onClick={handleShare} className="flex-1">
                  Generate Link
                </Button>
                <Button variant="outline" onClick={() => setShowShareModal(false)} className="flex-1">
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReportCard;